import { createSlice } from '@reduxjs/toolkit';

// Slice
const slice = createSlice({
  name: 'section',
  initialState: {
    section: null,
  },
  reducers: {
    setSection: (state, { payload }) => {
      state.section = payload;
    },
  },
});

// Actions
export const { setSection } = slice.actions;

export default slice.reducer;
